import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import StripePaymentForm from "./StripePaymentForm";
import { stripePubKey } from "../util/backendUtilities";

const stripePromise = loadStripe(stripePubKey);

const StripeContainer = ({ formData, amount }) => {
  return (
    <Elements stripe={stripePromise}>
      <StripePaymentForm formData={formData} amount={amount} />
    </Elements>
  );
};

export default StripeContainer;
